// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-page {
  max-width: 600px;
  margin: 60px auto;
  padding: 20px;
}

.success-card {
  text-align: center;
  padding: 48px 32px;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: var(--success);
  color: white;
  font-size: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.success-card h1 {
  font-size: 32px;
  margin-bottom: 16px;
  color: var(--text-dark);
}

.success-message {
  font-size: 18px;
  color: var(--text-dark);
  margin-bottom: 16px;
}

.success-details {
  color: var(--text-light);
  margin-bottom: 24px;
  line-height: 1.6;
}

.session-id {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: var(--text-light);
}

.session-id code {
  font-family: monospace;
  color: var(--text-dark);
  font-weight: 600;
}

.success-actions {
  margin-top: 32px;
}

.success-actions .btn {
  padding: 16px 32px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .success-page {
    margin: 24px auto;
    padding: 16px;
  }

  .success-card {
    padding: 32px 20px;
  }

  .success-card h1 {
    font-size: 26px;
  }

  .success-message {
    font-size: 16px;
  }

  .success-actions .btn {
    padding: 14px 24px;
    font-size: 16px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Success.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".success-page {\n  max-width: 600px;\n  margin: 60px auto;\n  padding: 20px;\n}\n\n.success-card {\n  text-align: center;\n  padding: 48px 32px;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: var(--success);\n  color: white;\n  font-size: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n}\n\n.success-card h1 {\n  font-size: 32px;\n  margin-bottom: 16px;\n  color: var(--text-dark);\n}\n\n.success-message {\n  font-size: 18px;\n  color: var(--text-dark);\n  margin-bottom: 16px;\n}\n\n.success-details {\n  color: var(--text-light);\n  margin-bottom: 24px;\n  line-height: 1.6;\n}\n\n.session-id {\n  padding: 12px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.session-id code {\n  font-family: monospace;\n  color: var(--text-dark);\n  font-weight: 600;\n}\n\n.success-actions {\n  margin-top: 32px;\n}\n\n.success-actions .btn {\n  padding: 16px 32px;\n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .success-page {\n    margin: 24px auto;\n    padding: 16px;\n  }\n\n  .success-card {\n    padding: 32px 20px;\n  }\n\n  .success-card h1 {\n    font-size: 26px;\n  }\n\n  .success-message {\n    font-size: 16px;\n  }\n\n  .success-actions .btn {\n    padding: 14px 24px;\n    font-size: 16px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
